import React from 'react';
import { Activity, Users, Plus } from 'lucide-react';
import Card from '../ui/Card';

const HeaderStats = ({
  players,
  matches,
  canWriteMatches,
  setShowMatchModal,
  setFormError,
}) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-10">
      <Card className="p-6 flex flex-col justify-between h-32 hover:border-zinc-300 transition-colors">
        <div className="flex justify-between items-start">
          <span className="text-[10px] font-bold uppercase tracking-widest text-zinc-400">
            Total Players
          </span>
          <Users className="w-4 h-4 text-zinc-300" />
        </div>
        <div className="mt-auto">
          <h3 className="text-3xl font-bold text-zinc-900 tracking-tight">
            {players.length}
          </h3>
        </div>
      </Card>

      <Card className="p-6 flex flex-col justify-between h-32 hover:border-zinc-300 transition-colors">
        <div className="flex justify-between items-start">
          <span className="text-[10px] font-bold uppercase tracking-widest text-zinc-400">
            Matches
          </span>
          <Activity className="w-4 h-4 text-zinc-300" />
        </div>
        <div className="mt-auto">
          <h3 className="text-3xl font-bold text-zinc-900 tracking-tight">
            {matches.length}
          </h3>
        </div>
      </Card>

      {canWriteMatches ? (
        <button
          onClick={() => {
            setShowMatchModal(true);
            setFormError('');
          }}
          className={`
            h-32 rounded-lg p-6 text-left transition-all bg-zinc-900
            hover:bg-black text-white shadow-lg hover:shadow-xl 
            flex flex-col justify-between group relative overflow-hidden
          `}
        >
          <div className="relative z-10 flex justify-between items-start w-full">
            <span className="text-[10px] font-bold uppercase tracking-widest text-zinc-400">
              Quick Action
            </span>
            <Plus className="w-5 h-5 text-white group-hover:rotate-90 transition-transform" />
          </div>
          <div className="relative z-10 mt-auto">
            <h3 className="text-lg font-bold text-white tracking-tight">
              Log Match
            </h3>
            <p className="text-zinc-400 text-xs mt-1">
              10 Goals to Win
            </p>
          </div>
        </button>
      ) : (
        <Card className="h-32 p-6 flex flex-col justify-between bg-zinc-50">
          <div className="flex justify-between items-start">
            <span className="text-[10px] font-bold uppercase tracking-widest text-zinc-400">
              View Only
            </span>
            <Activity className="w-4 h-4 text-zinc-300" />
          </div>
          <div className="mt-auto">
            <h3 className="text-lg font-bold text-zinc-600 tracking-tight">
              Read Access
            </h3>
            <p className="text-zinc-400 text-xs mt-1">
              Contact admin for write permissions
            </p>
          </div>
        </Card>
      )}
    </div>
  );
};

export default HeaderStats;
